import styled, {css} from 'styled-components';
import StyledIcon from '../../../../atoms/Icon/styles';
import colors from '../../../../theme/constants/colors';
import typography from '../../../../theme/typography';
import {StyledProps} from './typings';
import Link from 'next/link';

const size = '40px';

const StyledPaginationArrow = styled(Link)<StyledProps & {href?: string | URL}>`
  ${(props) => css`
    cursor: ${props.$disabled ? 'default' : 'pointer'};
    user-select: none;
    text-decoration: none;
    text-align: center;
    white-space: nowrap;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #fff;
    color: ${props.$disabled ? colors.grey100 : colors.darkBlue100};
    border: 1px solid ${colors.grey100};
    width: 100%;
    height: ${size};
    padding-bottom: 1px;
    ${props.$leftArrow ? 'padding-right: 3px' : 'padding-left: 2px'};

    @media only screen and (min-width: 400px) {
      width: ${size};
    }

    // Styling to counter default styling from bootstap.css
    // TODO remove once sass files are removed
    &:hover {
      color: inherit;
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover {
        color: ${colors.red100};
        border-color: ${colors.red100};

        ${StyledIcon} {
          color: ${colors.red100};
        }
      }
    }

    ${props.$disabled &&
    `
    pointer-events: none;
    
    ${StyledPaginationArrowLabel}{
      color: ${colors.grey100};
    }
    `}
  `}
`;

export const StyledPaginationArrowLabel = styled.span`
  ${typography.Subtitle3}
  color: inherit;
  margin: 0 5px;

  @media only screen and (min-width: 400px) {
    display: none;
  }
`;

export default StyledPaginationArrow;
